<template>
  <div class="home">
    <vxe-table ref="xTable" class="mytable-style" style="margin: 5px;font-size:5px" border resizable height="730"
      :scroll-y="{ enabled: false }" :data="searchData" :row-config="{ height: 25 }" :span-method="mergeRowMethod"
      show-overflow align="center" :cell-class-name="cellClassName">
      <vxe-column v-if="false" field="id" title="id"></vxe-column>
      <vxe-column type="html" sortable show-overflow="false" width="100" field="customerID" :title="this.$t('customerID')"></vxe-column>
      <vxe-column type="html" width="80" show-overflow="false" field="bikeID" :title="this.$t('bikeID')"></vxe-column>
      <vxe-column type="html" width="80" show-overflow="false" field="model" :title="this.$t('model')"></vxe-column>
      <vxe-column type="html" width="150" show-overflow="false" field="project" :title="this.$t('projectName')"></vxe-column>
      <vxe-column type="html" show-overflow="false" width="300" field="project_Desription" :title="this.$t('projectdescription')"
        align="left"></vxe-column>
      <vxe-column show-overflow="false" type="html" width="%8" field="head" :title="this.$t('principal')"></vxe-column>
      <vxe-column align="left" width="120" field="step.stepName" type="html" :title="this.$t('step')">
        <template #default="{ row }">
          <span v-if="row.step.stepName !== 'AddStep'">{{
              row.step.stepName
          }}</span>
        </template>
      </vxe-column>
      <vxe-column type="html" width="105" field="step.planTime" :title="this.$t('startTime')">
        <template #default="{ row }">
          <span v-if="row.step.startTime">{{
              new Date(row.step.startTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column type="html" width="105" field="step.planTime" :title="this.$t('planendtime')">
        <template #default="{ row }">
          <span v-if="row.step.planTime">{{
              new Date(row.step.planTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column type="html" width="105" field="step.actTime" :title="this.$t('actendtime')">
        <template #default="{ row }">
          <span v-if="row.step.actTime">{{
              new Date(row.step.actTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column type="html" width="90" :title="this.$t('progress')">
        <template #default="{ row }">
          <div v-html="isDelay(row.step)"></div>
        </template>
      </vxe-column>
      <vxe-column width="90" field="changeProcess" :title="this.$t('progressinfo')">
        <template #default="{ row }">
          <a v-if="!(row.status == '已结案' || row.status == '关闭')" style="color: #3071B9;;cursor: pointer;font-size: 8px;"
            v-on:click="changeProcess(row)">{{this.$t('vieworinput')}}</a>
        </template>
      </vxe-column>
      <vxe-column align="left" show-overflow="false" field="remark" :title="this.$t('remark')" type="html"></vxe-column>
      <vxe-column align="left" field="status" :title="this.$t('status')" type="html" width="80" :filters="[
        { label: '进行中', value: '进行中' },
        { label: '已结案', value: '已结案' },
        { label: '已关闭', value: '关闭' },
      ]" :filter-multiple="false">
      </vxe-column>
    </vxe-table>
  </div>

  <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="dialogShow">
    <div>
      <div><strong>请选择项目类别:</strong></div>
      <div @click="MenuClick('定制化配件')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">定制化配件</span>
      </div>
      <div @click="MenuClick('定制程序')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">定制程序</span>
      </div>
      <div @click="MenuClick('B类协议联调')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">B类协议联调</span>
      </div>
    </div>
  </el-dialog>

  <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="AddDialogShow2">
    <div style="padding:10px;margin: 0 auto; width: 800px; background-color: #e9ecef;">
      <div style="margin-bottom: 20px;"><strong style="font-size: 18px;">新增项目</strong></div>
      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px;">客户编号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" autosize :fetch-suggestions="CustomerIDSearch"
            v-model="FormData.CustomerID" placeholder="请输入客户编号"></el-autocomplete>
        </el-col>

        <el-col :offset="3" :span="2">
          <span style="line-height: 35px;">车款编号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" autosize :fetch-suggestions="BikeIDSearch"
            v-model="FormData.BikeID" placeholder="请输入车款编号"></el-autocomplete>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px;">电机型号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" autosize :fetch-suggestions="ModelSearch" v-model="FormData.Model"
            placeholder="请输入电机型号"></el-autocomplete>
        </el-col>

        <el-col :offset="3" :span="2">
          <span style="line-height: 35px;">负责人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" autosize v-model="FormData.Head" :fetch-suggestions="HeadSearch"
            placeholder="请输入负责人名称"></el-autocomplete>
        </el-col>

      </el-row>

      <br>

      <el-row>


        <el-col :span="2">
          <span style="line-height: 35px;">关注人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" autosize v-model="FormData.Follower"
            :fetch-suggestions="HeadSearch" placeholder="请输入关注人名称"></el-autocomplete>
        </el-col>
        <el-col :offset="3" :span="2">
          <span style="line-height: 35px;">确认人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete class="inline-input w-100" v-model="FormData.Confirmer" :fetch-suggestions="HeadSearch"
            placeholder="请输入确认人名称"></el-autocomplete>
        </el-col>
      </el-row>

      <br>

      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px;">项目名称</span>
        </el-col>
        <el-col :span="21">
          <el-autocomplete class="inline-input w-100" autosize :fetch-suggestions="ProjectNameSearch"
            v-model="FormData.Project" placeholder="请输入开发项目名称"></el-autocomplete>
        </el-col>
      </el-row>

      <br>

      <el-row>
        <el-col :span="2">
          <span style="line-height: 30px;">项目描述</span>
        </el-col>
        <el-col :span="21">
          <el-input v-model="FormData.Project_Desription" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入项目备注">
          </el-input>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 30px;">项目备注</span>
        </el-col>
        <el-col :span="21">
          <el-input v-model="FormData.Remark" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入项目备注">
          </el-input>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 30px;">项目状态</span>
        </el-col>
        <el-col :span="7">
          <el-select type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" v-model="FormData.Status">
            <el-option value="进行中"></el-option>
            <el-option value="已结案"></el-option>
            <el-option value="关闭"></el-option>
          </el-select>
        </el-col>
      </el-row>

      <br />
      <el-row></el-row>
      <el-row :gutter="10">
        <el-col :span="5"></el-col>
        <el-col :span="4">
          <el-button v-if="isEdit" @click="deleteProjectClick" type="danger">删除</el-button>
        </el-col>
        <el-col :span="2">
          <el-button @click="confirm" type="primary">确定</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="cancelClick">取消</el-button>
        </el-col>
      </el-row>

    </div>
  </el-dialog>

  <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="ChangeProcessDialog">
    <div style="padding:10px;margin: 0 auto; width: 800px; background-color: #e9ecef;">
      <div style="margin-bottom: 20px;"><strong style="font-size: 18px;">{{ StepItem.step.stepName }}</strong></div>
      <br />
      <el-row>
        <el-col :offset="0" :span="3">
          <strong style="line-height: 35px;">项目开始时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker type="date" :autosize="{ minRows: 2, maxRows: 10 }" v-model="StepItem.step.startTime"
            placeholder="未完成">
          </el-date-picker>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :span="3">
          <strong style="line-height: 35px;">计划完成时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker type="date" :autosize="{ minRows: 2, maxRows: 10 }" v-model="StepItem.step.planTime"
            placeholder="未完成">
          </el-date-picker>
        </el-col>

        <el-col :offset="3" :span="3">
          <strong style="line-height: 35px;">实际完成时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker type="date" :autosize="{ minRows: 2, maxRows: 10 }" v-model="StepItem.step.actTime"
            placeholder="未完成">
          </el-date-picker>
        </el-col>
      </el-row>
      <br>

      <br>



      <el-row>

        <el-col :span="2">
          <strong>项目状态</strong>
        </el-col>

        <el-col :offset="1" :span="3">
          <span style="font-size:large;line-height:20px;text-align: center;" v-html="isDelay(StepItem.step)"></span>
        </el-col>
      </el-row>

      <el-row style="margin-bottom:30px;margin-top:20px" v-if="StepItem.step.isDelay">

        <el-col :span="2">
          <strong style="line-height: 30px;">逾期原因</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <el-input v-model="StepItem.step.delayReason" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入逾期原因">
          </el-input>
        </el-col>
      </el-row>

      <el-row v-if="StepItem.step.isDelay">
        <el-col :span="2">
          <strong style="line-height: 30px;">逾期措施</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <el-input v-model="StepItem.step.delayMeasure" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入逾期措施">
          </el-input>
        </el-col>
      </el-row>

      <br />
      <br />

      <el-row>
        <el-col :span="2">
          <strong style="line-height: 30px;">附件</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <table style="margin-top: 20px;background-color: white; border: #e3e6f0 solid 2px">
            <tr style="height: 30px;">
              <th style="width: 300px;">文件名</th>
              <th style="width: 300px;">操作</th>
            </tr>
            <tr style="height: 40px;" :key="index" v-for="(item, index) in StepItem.step.attchments">
              <td>{{ item.fileName }}</td>
              <td>
                <button @click="previewClick(item)"
                  style="background-color: transparent;border-color: transparent;color: #3071B9;">下载</button>
                <button v-show="Role.updateProgress" @click="deleteClick(item)"
                  style="background-color: transparent;border-color: transparent;color: #3071B9;">删除</button>
              </td>
            </tr>
            <td style="padding:15px" v-if="!StepItem.step.attchments.length" colspan="2">暂无文件</td>
          </table>
        </el-col>
      </el-row>
      <el-upload v-show="Role.updateProgress" :show-file-list="false" :action="null" :http-request="UploadData">
        <button style="background-color: transparent;border-color: transparent;color: #3071B9;">点击上传文件</button>
      </el-upload>
      <br />
      <br />

      <el-row :gutter="10">
        <el-col v-show="Role.updateProgress" :span="16">
          <!-- <el-button v-if="StepItem.projectType != '定制化配件'" @click="AddNewStepClick(StepItem)" type="primary">增加新一轮测试
          </el-button> -->
        </el-col>

        <el-col v-show="Role.updateProgress" :span="2">
          <el-button @click="confirmUpdateStep(StepItem)" type="primary">确定</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="ChangeProcessDialog = false;">返回</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

  <div>
    <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="timelineShow">
      <div id="chartcontainer">

      </div>
    </el-dialog>
  </div>

</template>

<script>
import Swal from "sweetalert2";
import {
  AddProgressItem,
  GetProgressList,
  GetUser,
  UpdateProgressItem,
  UpdateStepItem,
  AddNewStep,
  DeleteProgress
} from "../common/httphelper";
import XEUtils, { map, random } from "xe-utils";
import getRole from "../common/role";
import upload from "element-plus/es/components/upload/src/ajax";
import ApexCharts from 'apexcharts';
import moment from 'moment'
// @ is an alias to /src


const OSS = require("ali-oss")

const client = new OSS({
  // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
  region: "oss-cn-guangzhou",
  // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
  accessKeyId: "LTAItdKUSj0MOUTc",
  accessKeySecret: "LhqjeZY9lC4rpAStCEMAIir7v6kFhp",
  // 刷新临时访问凭证的时间间隔，单位为毫秒。
  refreshSTSTokenInterval: 300000,
  // 填写Bucket名称。
  bucket: "motinova-admin",
});


// 对Date的扩展，将 Date 转化为指定格式的String
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

function getWeekNum(dt) {
  let d1 = new Date(dt);
  let d2 = new Date(dt);
  d2.setMonth(0);
  d2.setDate(1);
  let rq = d1 - d2;
  let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
  let num = Math.ceil(days / 7);
  return num;
}

// 获取周
// startDate 2022-03-26
// endDate 2022-04-26
function getWeak(start, end) {
  // 1、获取开始日期属于第几周，哪年
  let startWeekNum = this.getWeekNum(start)
  let startYearNum = parseInt(start.split('-')[0])

  if (startWeekNum >= 53) {
    startWeekNum = 52
  }

  // 2、获取结束日期属于第几周，哪年
  let endWeekNum = this.getWeekNum(end)
  let endYearNum = parseInt(end.split('-')[0])

  if (endWeekNum >= 53) {
    endWeekNum = 52
  }

  // 3、计算周数
  let result = []
  let yearAdd = 0 // 跨年数
  let yearWeekNum = startWeekNum // 当前取到的周数
  for (let i = 0; i <= ((endYearNum - startYearNum) * 52 - startWeekNum + endWeekNum); i++) {
    if ((startWeekNum + i) <= 0) { // 如果开始周数是0，则取开始年上一年的52周
      result.push((startYearNum - 1) + "52")
    } else {
      if (yearWeekNum === 52) {
        yearAdd++
      }
      yearWeekNum = startWeekNum + i - yearAdd * 52
      if (yearWeekNum <= 0) { // 如果开始周数是0，则取开始年上一年的52周
        result.push(startYearNum + "52")
      } else {
        if (yearWeekNum < 10) {
          result.push((startYearNum + yearAdd) + "0" + yearWeekNum)
        } else {
          result.push((startYearNum + yearAdd) + "" + yearWeekNum)
        }
      }
    }
  }
  return result
}


/**
 * @param {Object} json
 * @param {Object} type： 默认不传 ==>全部小写;传1 ==>全部大写;传2 ==>首字母大写
 * 将json的key值进行大小写转换
 */
function jsonKeysToCase(json, type) {
  if (typeof json == "object") {
    var tempJson = JSON.parse(JSON.stringify(json));
    toCase(tempJson);
    return tempJson;
  } else {
    return json;
  }

  //对象字母转换
  function toCase(json) {
    if (typeof json == "object") {
      if (Array.isArray(json)) {
        json.forEach(function (item) {
          toCase(item);
        });
      } else {
        for (var key in json) {
          var item = json[key];
          if (typeof item == "object") {
            toCase(item);
          }
          delete json[key];
          switch (type) {
            case 1:
              //key值全部大写
              json[key.toLocaleUpperCase()] = item;
              break;
            case 2:
              //key值首字母大写，其余小写
              json[key.substring(0, 1).toLocaleUpperCase() + key.substring(1)] = item;
              break;
            default:
              //默认key值全部小写
              json[key.toLocaleLowerCase()] = item;
              break;
          }
        }
      }
    }
  }
}

export default {
  data() {
    return {
      FormData: this.FormDataObj(),
      dialogShow: false,
      tableData3: [],
      searchData: [],
      filterName: "",
      isEdit: false,
      Role: {},
      AddDialogShow2: false,
      Users: [],
      ChangeProcessDialog: false,
      StepItem: {},
      timelineShow: false,
      RawData: [],
    };
  },
  methods: {

    //预览
    previewClick(item) {
      window.open(item.fileUrl, '_blank')
    },


    //上传附件到阿里云
    async UploadData(file) {
      try {
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        const r1 = await client.put(
          "ProductManagerProcess/" + Math.random().toString(36).substr(2) + file.file.name,
          file.file
        );
        Swal.close();
        if (r1.url === null) {
          return;
        }
        const { value: uploadFileName } = await Swal.fire({
          title: '请输入文件名',
          input: 'text',
          inputPlaceholder: '请输入文件名',
          allowOutsideClick: false,
          showCloseButton: false
        })

        if (uploadFileName) {
          this.StepItem.step.attchments.push({ fileName: uploadFileName, fileUrl: r1.url })
        }

        this.uploadShow = true;
      } catch (e) {
        console.error("error: %j", e);
      }
      this.refreshList()
    },

    //删除文件
    deleteClick(item) {
      this.StepItem.step.attchments = this.StepItem.step.attchments.filter(x => x.fileUrl !== item.fileUrl)
    },

    ///是否延期
    isDelay(row) {

      row.isDelay = false

      if (!(row.planTime)) {
        return "<div style='background:#e9ecef;color:black'>" + "未计划" + "<div/>";
      }

      if (row.status == "关闭") {
        return "<div style='background:#e9ecef;color:black'>" + "已关闭" + "<div/>";
      }

      var endDate = new Date(new Date(new Date().toDateString()).getTime()); //今天的23时59分59秒
      if (!row.actTime && new Date(row.planTime) < endDate) {
        row.isDelay = true
        return '<div style="background:#f03e3e;color:white">已逾期<div/>'; //无实际截止时间且计划完成时间小于今天
      }
      if (row.actTime && new Date(row.actTime) > new Date(row.planTime)) {
        row.isDelay = true
        return '<div style="background:#0ca678;color:white">' + "逾期完成" + "<div/>";
      }
      return row.actTime
        ? "<div style='background:#10dea0;color:white'>" + `已完成` + "<div/>"
        : "进行中";
    },

    Export() {
      this.$refs.xTable.exportData({ type: "html" });
    },

    //菜单点击
    MenuClick(menustr) {
      this.FormData.ProjectType = menustr;
      this.AddDialogShow2 = true;
    },

    ///添加项目
    AddClick() {
      this.isEdit = false;
      this.FormData = this.FormDataObj();
      this.dialogShow = true;
    },

    ///编辑行
    Edit(row) {
      this.isEdit = true;
      let items = this.tableData3.filter((item) => {
        return item.id == row.id;
      });

      this.FormData = jsonKeysToCase(items[0], 2);

      this.FormData.Steps = this.FormData.Steps.filter(item => item.StepName != "AddStep")

      this.AddDialogShow2 = true;
    },


    //修改进度
    changeProcess(row) {
      this.ChangeProcessDialog = true
      this.StepItem = JSON.parse(JSON.stringify(row))
    },

    //新增阶段
    AddNewStepClick(row) {
      AddNewStep(row.id).then(async (res) => {
        if (res.data.data) {
          this.ChangeProcessDialog = false;
          this.refresh()
          await Swal.fire({
            icon: "success",
            title: "新增成功",
            showConfirmButton: false,
            timer: 3000,
          });

        } else {

        }
      })
    },

    confirmUpdateStep(item) {
      UpdateStepItem(item.id, item.step).then(res => {
        if (res.data.data) {
          this.ChangeProcessDialog = false;
          this.refresh()
        }
      })
    },

    //智能提示
    CustomerIDSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.customerID));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    //智能提示
    ModelSearch(query, cb) {
      let mymap = new Map();
      this.tableData3
        .filter((item) => item.bikeID == this.FormData.BikeID)
        .forEach((item) => mymap.set(item.model));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    //智能提示
    BikeIDSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.bikeID));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    HeadSearch(query, cb) {
      let mymap = new Map();
      this.Users.forEach((item) => mymap.set(item.realName));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    ProjectNameSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.project));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    //合并单元格方法
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {

      let currentrowspan = row["steps"].length;

      const mergeIdCol = [
        "head",
        "remark",
        "project_Desription",
        "operate",
        "results",
        "status",
      ];
      const cellValue = row[column.property];
      const prevRow = visibleData[_rowIndex - 1];
      let nextRow = visibleData[_rowIndex + 1];

      if (mergeIdCol.includes(column.property)) {
        if (prevRow && prevRow["id"] === row["id"]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          return { rowspan: currentrowspan, colspan: 1 };
        }
      }


      if (row.step.stepName == "AddStep") {
        if (column.property == "step.stepName") {
          return { rowspan: 1, colspan: 5 };
        } else {
          return { rowspan: 0, colspan: 0 }
        }
      }


      if (cellValue && column.property === "customerID") {
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }

      if (cellValue && column.property === "bikeID") {
        if (
          prevRow &&
          prevRow[column.property] === cellValue &&
          prevRow["customerID"] === row["customerID"]
        ) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (
            nextRow &&
            nextRow[column.property] === cellValue &&
            nextRow["customerID"] === row["customerID"]
          ) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }

      if (cellValue
        &&
        column.property === "model"
        || column.property == "project") {
        if (
          prevRow &&
          prevRow[column.property] === cellValue &&
          prevRow["bikeID"] === row["bikeID"] &&
          prevRow["customerID"] === row["customerID"]
        ) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (
            nextRow &&
            nextRow[column.property] === cellValue &&
            nextRow["bikeID"] === row["bikeID"] &&
            nextRow["customerID"] === row["customerID"]
          ) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }


    },

    //新建提交确认
    async confirm() {
      if (!this.FormData.CustomerID) {
        Swal.fire("客户编号不能为空");
        return;
      }
      if (!this.FormData.BikeID) {
        Swal.fire("车款编号不能为空");
        return;
      }

      if (!this.FormData.Model) {
        Swal.fire("电机型号不能为空");
        return;
      }

      if (!this.FormData.Project) {
        Swal.fire("开发项目不能为空");
        return;
      }

      if (!this.FormData.Head) {
        Swal.fire("负责人不能为空");
        return;
      }

      if (this.FormData.Status === "关闭" || this.FormData.Status === "已结案") {
        let confirmCloseProj = false;
        await Swal.fire({
          title: "确定操作吗?",
          text: "项目状态更改为'已结案'或'关闭'将无法再进行修改!",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then((res) => {
          confirmCloseProj = res.isConfirmed;
        });
        if (!confirmCloseProj) return;
      }

      if (!this.isEdit) {
        await AddProgressItem(this.FormData).then(async (res) => {
          if (res.data.data) {
            this.dialogShow = false;
            this.AddDialogShow2 = false;
            this.refresh();
            Swal.fire("已创建流程");
          } else {
            Swal.fire({
              icon: "warning",
              title: "该条目存在未审批的流程",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
      } else {
        await UpdateProgressItem(this.FormData).then(async (res) => {
          if (res.data.data) {
            this.AddDialogShow2 = false
            this.refresh();
            Swal.fire("已创建流程");
          } else {
            Swal.fire({
              icon: "warning",
              title: "该条目存在未审批的流程",
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
      }
    },

    //根据内容改变颜色
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        if (row.status === "关闭") {
          return "col-gray";
        }
        if (row.status === "已结案") {
          return "col-green";
        }
      }
    },

    ///取消窗口
    cancelClick() {
      this.dialogShow = false;
      this.AddDialogShow2 = false;
      this.FormData = this.FormDataObj();
    },

    ///刷新数据
    async refresh() {
      await GetProgressList().then((res) => {
        let data = [];

        this.RawData = JSON.parse(JSON.stringify(res.data))

        res.data.forEach((item) => {

          let addStep = JSON.parse(JSON.stringify(item.steps[0]))

          //增加按钮  增加阶段的
          addStep.stepName = 'AddStep'
          if (this.Role.updateProgress) {
            if (item.projectType == "B类协议联调") {
              item.steps.push(
                addStep
              )
            }

            if (item.projectType == "定制程序") {
              item.steps.splice(item.steps.length - 1, 0,
                addStep
              )
            }
          }


          item.steps.forEach(step => {
            let newItem = JSON.parse(JSON.stringify(item));
            newItem.step = step
            data.push(newItem);
          }
          )
        });

        this.tableData3 = data;
      });
      this.searchEvent();
    },

    //全表搜索
    searchEvent() {
      const filterName = XEUtils.toValueString(this.filterName).trim().toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "customerID",
          "bikeID",
          "model",
          "devProcess",
          "remark",
          "project",
          "project_Desription",
          "head",
          "status",
          "results",
        ];
        const rest = this.tableData3.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1
          )
        );
        this.searchData = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `<span class="keyword-lighten">${match}</span>`
            );
          });
          return item;
        });
      } else {
        this.searchData = this.tableData3;
      }
    },

    deleteProjectClick() {
      DeleteProgress(this.FormData.Id).then(res => {
        if (res.data) {
          Swal.fire({
            icon: "success",
            title: "已创建流程",
            showConfirmButton: false,
            timer: 3000,
          });
          this.AddDialogShow2 = false
          this.refresh();
        } else {
          Swal.fire({
            icon: "warning",
            title: "该条目存在未审批的流程",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      })
    },

    async timelineShowClickBak() {
      this.timelineShow = true;
      await this.refresh();
      let containerElement = document.querySelector("#chartcontainer")
      if (containerElement) {
        containerElement.innerHTML = '<div id="chart"></div>'
      }

      let options = {
        series: [],
        chart: {
          height: 800,
          type: 'rangeBar',
          locales: [{
            "name": "en",
            "options": {
              "months": ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
              "shortMonths": ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
              "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              "toolbar": {
                "exportToSVG": "保存为SVG",
                "exportToPNG": "保存为PNG",
                "exportToCSV": "保存为CSV",
                "menu": "菜单",
                "selection": "选择",
                "selectionZoom": "选择缩放",
                "zoomIn": "放大",
                "zoomOut": "缩小",
                "pan": "选择拖曳",
                "reset": "重置缩放"
              }
            }
          }],
        },
        plotOptions: {
          bar: {
            rangeBarGroupRows: true,
            horizontal: true,
            dataLabels: {
              hideOverflowingLabels: true
            }
          }
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
            format: 'MM月dd日',
            formatter: undefined,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            //var label = opts.w.globals.labels[opts.dataPointIndex]
            var a = moment(val[0])
            var b = moment(val[1])
            var diff = b.diff(a, 'days')
            return diff + "天"
          },
          style: {
            colors: ['#f3f4f5', '#fff']
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "yyyy-MM",
              day: 'MM-dd',
              hour: 'HH:mm',
            },
          }
        },
        yaxis: {
          show: true,
        },
        grid: {
          row: {
            colors: ['#f3f4f5', '#fff'],
            opacity: 1,
          }
        },
        legend: {
          position: 'top'
        }
      };

      ///////////////////////算法

      let series = []

      this.RawData.forEach(item => {

        let data = []

        let serie = {}

        item.steps.forEach(step => {
          if (!(step.startTime || step.actTime)) {
            return
          }
          serie.name = item.project

          data.push(
            {
              x: item.project + '-' + step.stepName,
              y: [
                new Date(step.startTime).getTime(),
                new Date(step.actTime).getTime(),
              ]
            }
          )

        })

        if (serie.name) {
          series.push({
            name: serie.name,
            data: data
          })
        }

      })

      /////////////


      options.series = series


      this.$nextTick(() => {
        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
      })

    },

    async timelineShowClick() {
      this.timelineShow = true;
      await this.refresh();
      let containerElement = document.querySelector("#chartcontainer")
      if (containerElement) {
        containerElement.innerHTML = '<div id="chart"></div>'
      }

      var options = {
        series: [{
          name: '未完成',
          data: [8,6,2,8,14,5,8,6,1,5,4,8,4,5,6,2,4,8]
        }, {
          name: '已完成',
          data: [1,2,3,8,5,6,4,5,2,5,4,8,3,1,5,8,4,6,3,3,6]
        }, {
          name: '已逾期',
          data: [2,5,8,4,6,8,2,1,0,1,1,1,0,0,1]
        }],
        chart: {
          type: 'bar',
          height: 600
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: undefined
        },
        yaxis: {
          title: {
            text: '任务数'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "个项目"
            }
          }
        }
      };

      let catlog = []
      for (let index = 0; index < 52; index++) {
        catlog.push('第'+(index+1)+'周')
      }
      options.xaxis.categories = catlog

      this.$nextTick(() => {
        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
      })

    },

    ///FromData对象
    FormDataObj() {
      return {
        Id: undefined,
        CustomerID: "",
        BikeID: "",
        Model: "",
        Project: "",
        Project_Desription: "",
        ProjectType: "",
        Steps: [],
        DevProcess: "",
        Remark: "",
        Head: "",
        Follower: "",
        Confirmer: "",
        Status: "进行中",
      };
    },
  },
  mounted() {
    this.Role = getRole();
    this.refresh();
    GetUser().then(res => {
      this.Users = res.data
    })
  },
};
</script>

<style>
.el-overlay {
  z-index: 999 !important;
}

.inputtitle {
  line-height: 10px;
}

.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}

.Steps {
  padding: 10px 0;
  background: #ededed;
}

.progresstable {
  font-size: 0.6rem;
}

.mytable-style.vxe-table .vxe-body--column.col-gray {
  background-color: #e9ecef;
  color: black;
}

.mytable-style.vxe-table .vxe-body--column.col-green {
  background-color: #d3f9d8;
  color: black;
}

.menuDiv {
  margin: 20px auto;
  height: 80px;
  background-color: #e9ecef;
  width: 600px;
  color: #555;
  cursor: pointer;
}

.menuDiv:hover {
  background-color: #3071b9;
  color: #fff;
}
</style>